<template>
  <v-container fluid grid-list-md class="candidate edit experiences">
    <v-progress-linear
      v-if="loading"
      :color="themes.candidate.light.loading"
      :height="5"
      indeterminate
    />

    <v-data-iterator
      v-else
      :items="sortedExperiences"
      no-data-text=""
      content-tag="div"
      style="width: 100%;"
      hide-actions
      expand
    >
      <template slot="item" slot-scope="{ item: experience }">
        <Experience
          :experience="experience"
          :profile="profile"
          @refresh="refresh"
        />
      </template>
    </v-data-iterator>
    <div v-if="adding" class="mt-3">
      <Experience :experience="adding" :profile="profile" @refresh="refresh" />
    </div>
    <div v-if="noExperience" class="mt-3">
      <NoExperience
        :profile="profile"
        :experience="noExperience"
        @refresh="refresh"
        @cancelled="noExperienceCancelled"
      />
    </div>
    <div v-else class="text-xs-center py-4">
      <div>
        <v-chip slot="activator">
          <v-avatar>
            <v-btn
              slot="activator"
              :color="themes.candidate.light.secondaryActionButton"
              @click="createExperience"
              small
              fab
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-avatar>
          Add work experience
        </v-chip>
      </div>
      <div v-if="experiences.length == 0" class="mt-4">
        <v-chip slot="activator">
          <v-avatar>
            <v-btn
              slot="activator"
              :color="themes.candidate.light.secondaryActionButton"
              @click="createNoExperience"
              small
              fab
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-avatar>
          No work experience
        </v-chip>
      </div>
    </div>
  </v-container>
</template>

<script>
// Components
import Experience from "@/components/candidate/profile/edit/experience/Experience";
import NoExperience from "@/components/candidate/profile/edit/experience/NoExperience";

// Helpers
import _ from "lodash";

export default {
  components: { Experience, NoExperience },

  created() {
    this.refresh();
  },

  props: { profile: { type: Object, required: true }, actionItems: Array },

  data() {
    return {
      adding: null,
      noExperience: null,
      loading: true
    };
  },

  computed: {
    experiences() {
      return this.$store.getters["candidate/experiences/all"];
    },

    sortedExperiences() {
      if (!_.get(this, "experiences[0]")) return [];

      const experiences = JSON.parse(JSON.stringify(this.experiences));
      return experiences.sort(({ endsAt: a }, { endsAt: b }) => {
        if (!a) return -1;
        if (!b) return 1;
        if (new Date(a) > new Date(b)) return -1;
        if (new Date(a) < new Date(b)) return 1;
        return 0;
      });
    }
  },
  methods: {
    createExperience() {
      this.adding = {
        endsAt: null,
        errors: null,
        experiences: [],
        id: null,
        organization: { name: "", id: null },
        position: "",
        profile: this.profile,
        startsAt: null
      };
    },
    createNoExperience() {
      this.noExperience = {
        experiences: ["None"],
        profile: this.profile
      };
    },
    noExperienceCancelled() {
      this.noExperience = null;
    },

    refresh() {
      this.loading = true;

      this.$store.dispatch("candidate/experiences/fetchAll").then(() => {
        this.adding = null;
        this.loading = false;
      });
    }
  }
};
</script>
